<template>
    <div
        :class="['edit-modal-mask', bModalEffectMask ? 'fade-in' : 'fade-out']"
        v-show="bModalMaskShow"
    >
        <transition name="collapse-list">
            <div class="edit-modal" v-show="bEditModalShow">
                <div class="edit-modal-header">
                    {{ title }}
                    <div class="close" @click="closeModal()"></div>
                </div>
                <div class="edit-modal-content">
                    <div class="edit-goods-list" v-if="arrChecked.length !== 0">
                        <ul v-if="arrChecked.length !== 0">
                            <li
                                v-for="(item, index) in arrChecked"
                                :key="item.id"
                            >
                                <div class="img-box">
                                    <img :src="item.mobile_thumb" alt="" />
                                </div>
                                <div class="goods-info">
                                    <div class="goods-name">
                                        {{ item.cate_name }}
                                        <span>{{ item.goods_name }}</span>
                                    </div>
                                    <div class="goods-attr">
                                        <div>重要参数：</div>
                                        <div
                                            v-for="(
                                                attrItem, attrIndex
                                            ) in item.attr_two"
                                            :key="attrIndex"
                                        >
                                            {{ attrItem.attr_name }}:{{
                                                attrItem.attr_value
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="edit-count"
                                    @click.stop="openCountPiker(index)"
                                >
                                    <p>{{ item.num || "选择数量" }}</p>
                                </div>
                                <!-- <div class="count">x {{item.num}}</div> -->
                                <div class="yx"></div>
                                <div
                                    class="delete"
                                    @click="deletedChange(index)"
                                ></div>
                            </li>
                        </ul>
                    </div>
                    <div class="edit-modal-top">
                        <div class="search">
                            <img
                                src="@/assets/images/ant/search.png"
                                alt=""
                                @click="searchChange()"
                            />
                            <input
                                type="text"
                                name=""
                                id=""
                                v-model="sKeyWord"
                                @change="searchChange"
                                @blur.prevent="changeBlur()"
                            />
                        </div>
                        <div
                            class="select"
                            @click="openPiker()"
                            v-if="!oGoodsInfo.goods_type_id"
                        >
                            <div class="name">{{ sSelectValue[0].value }}</div>
                            <div class="select-icon"></div>
                        </div>
                    </div>
                    <div class="goods-list"
                        v-infinite-scroll="loadMore"
                        infinite-scroll-disabled="true"
                        infinite-scroll-distance="0"
                        infinite-scroll-immediate-check="true"
                    >
                        <!-- <pull-to
                            :distance-index="3"
                            :top-config="TOP_DEFAULT_CONFIG"
                            :bottom-config="BOTTOM_DEFAULT_CONFIG"
                            :top-load-method="downRefresh"
                            :bottom-load-method="upRefresh"
                            :is-bottom-bounce="true"
                            bottom-block-height:0
                            top-block-height:0
                        > -->
                            <div v-if="!isNotData">
                                <div
                                    class="goods-item"
                                    v-for="(item, index) in arrGoodsList"
                                    :key="item.id"
                                >
                                    <img v-lazy="item.mobile_thumb" alt="" />
                                    <div class="goods-info">
                                        <p class="goods-name">
                                            {{ item.cate_name }}
                                            <span>{{ item.goods_name }}</span>
                                        </p>
                                        <div class="goods-attr">
                                            <div>重要参数：</div>
                                            <div
                                                v-for="(
                                                    attrItem, attrIndex
                                                ) in item.attr_two"
                                                :key="attrIndex"
                                            >
                                                {{ attrItem.attr_name }}:{{
                                                    attrItem.attr_value
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="add-btn"
                                        v-show="!active(item)"
                                        @click="selectGoods(item)"
                                    >
                                        添加
                                    </div>
                                    <!-- <div :class="['no-checked', active(item) ? 'checked':'']"></div> -->
                                    <!-- <div class="edit-count" @click.stop="openCountPiker(index)" v-show="active(item)">
                                        <p>{{item.num || '选择数量'}}</p>
                                    </div> -->
                                </div>
                                <div class="dropload-tip" v-if="isToEnd">
                                    我是有底线的
                                </div>
                            </div>
                            <div class="not-data" v-else>暂时还没有数据哦~</div>
                        <!-- </pull-to> -->
                    </div>
                </div>
                <div class="edit-btn">
                    <button class="confirm-btn" @click="confirm()">确定</button>
                </div>
            </div>
        </transition>
        <!-- 其他楼层选择品类 -->
        <awesome-picker
            ref="picker"
            :anchor="sSelectValue"
            :data="arrHushiSelectList"
            :colorConfirm="oPicker.colorConfirm"
            @confirm="confirmPickerHushi"
        ></awesome-picker>
        <!-- 一楼楼层选择品类 -->
        <awesome-picker
            ref="onePicker"
            :anchor="sSelectValue"
            :data="arrSelectList"
            :colorConfirm="oPicker.colorConfirm"
            @confirm="confirmPicker"
        ></awesome-picker>
        <!-- 选择数量 -->
        <awesome-picker
            ref="countPicker"
            :anchor="sSelectCountValue"
            :data="arrSelectCountList"
            :colorConfirm="oPicker.colorConfirm"
            @confirm="confirmCountPicker"
        ></awesome-picker>
    </div>
</template>

<script>
import PullTo from "vue-pull-to";
import { getGoodsList } from "@/js/map.js";
export default {
    name: "addModal",
    components: {
        PullTo,
    },
    data() {
        return {
            bModalEffectMask: false, // 动画开关
            bModalMaskShow: false, // mask开关

            TOP_DEFAULT_CONFIG: {
                pullText: "下拉刷新", // 下拉时显示的文字
                triggerText: "释放更新", // 下拉到触发距离时显示的文字
                loadingText: "加载中...", // 加载中的文字
                doneText: "加载完成", // 加载完成的文字
                failText: "加载失败", // 加载失败的文字
                loadedStayTime: 400, // 加载完后停留的时间ms
                stayDistance: 50, // 触发刷新后停留的距离
                triggerDistance: 70, // 下拉刷新触发的距离
            },
            BOTTOM_DEFAULT_CONFIG: {
                pullText: "上拉加载",
                triggerText: "释放更新",
                loadingText: "加载中...",
                doneText: "加载完成",
                failText: "加载失败",
                loadedStayTime: 400,
                stayDistance: 50,
                triggerDistance: 70,
            },

            nPage: 0, //页数
            sKeyWord: "", //搜索关键词
            arrGoodsList: [], // 产品列表
            arrChecked: [], // 选中列表
            isToEnd: false, // 是否到底
            isNotData: true, // 是否有数据

            oPicker: {
                colorConfirm: "rgba(33, 51, 102, 1)",
            },
            arrSelectList: [
                { value: "变频户式空气热泵机组", id: 200 },
                { value: "风机盘管机组", id: 201 },
                { value: "壁挂炉", id: 2 },
                { value: "中央新风系统", id: 206 },
                { value: "前置过滤器", id: 207 },
                { value: "中央净水机", id: 209 },
                { value: "美容软水器", id: 210 },
                { value: "净水机", id: 211 },
                { value: "零逃逸油烟机", id: 212 },
                { value: "大火力燃气灶", id: 213 },
            ], // 分类数组
            arrHushiSelectList: [
                { value: "风机盘管机组", id: 201 },
                { value: "壁挂炉", id: 2 },
                { value: "中央新风系统", id: 206 },
                { value: "前置过滤器", id: 207 },
                { value: "中央净水机", id: 209 },
                { value: "美容软水器", id: 210 },
                { value: "净水机", id: 211 },
                { value: "零逃逸油烟机", id: 212 },
                { value: "大火力燃气灶", id: 213 },
            ],
            sSelectValue: [{ value: "中央净水机", id: 209 }], // 选中的分类

            nActive: null,
            arrSelectCountList: [], // 数量数组
            sSelectCountValue: [{ value: 1 }], // 选中的数量

            scrollTop: null, //记住页面滚动位置
        };
    },
    props: {
        nFindex: {
            type: Number,
            default: () => {
                return 0;
            },
        },
        title: {
            type: String,
            default: "设备选型",
        },
        // 信息
        oGoodsInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
        bEditModalShow: {
            type: Boolean,
            default: false,
        },
    },
    filters: {},
    created() {
        for (let i = 1; i <= 50; i++) {
            this.arrSelectCountList.push({
                value: i,
            });
        }
    },
    mounted() {},
    computed: {},
    watch: {
        bEditModalShow: {
            handler(newValue, oldValue) {
                if (newValue) {
                    // this.oGoodsInfo = {}
                    this.arrChecked = [];
                    this.scrollTop =
                        document.documentElement.scrollTop ||
                        document.body.scrollTop;
                    document.body.classList.add("dialog");
                    this.bModalMaskShow = newValue;
                    this.bModalEffectMask = newValue;
                    this.nPage = 0;
                    this.arrGoodsList = [];
                    this.getGoodsList();
                } else {
                    document.body.classList.remove("dialog");
                    window.scrollTo(0, this.scrollTop);
                    this.nPage = 0;
                    this.sKeyWord = "";
                    this.arrGoodsList = [];
                    this.bModalEffectMask = newValue;
                    setTimeout(() => {
                        this.bModalMaskShow = newValue;
                    }, 500);
                }
            },
            immediate: true,
        },
    },
    methods: {
        // 点击放大镜
        searchChange() {
            this.nPage = 0;
            this.arrGoodsList = [];
            this.getGoodsList();
        },
        // 是否勾选
        active(item) {
            const index = this.arrChecked.findIndex((_) => _.id === item.id);
            return ~index ? true : false;
        },
        // 选择产品
        selectGoods(item) {
            const index = this.arrChecked.findIndex((_) => _.id === item.id);
            if (!~index) {
                item.num = 1;
                this.arrChecked.unshift(item);
            }
        },
        // 确定
        confirm() {
            if (this.arrChecked.length === 0) {
                this.$toast("您还没有选择产品！");
                return false;
            }
            this.arrChecked.forEach((item) => {
                switch (Number(item.system_id)) {
                    case 1:
                        item.system_name = "空气能冷暖两联供系统";
                        break;
                    case 2:
                        item.system_name = "热水系统";
                        break;
                    case 3:
                        item.system_name = "新风系统";
                        break;
                    case 4:
                        item.system_name = "中央水系统";
                        break;
                    case 5:
                        item.system_name = "全屋互联";
                        break;
                }
            });
            this.$emit("selectChange", this.arrChecked);
            this.closeSearchModal();
        },
        // 删除已选类容
        deletedChange(index) {
            this.arrChecked.splice(index, 1);
        },
        // 选择品类
        openPiker() {
            if (this.nFindex == 0) {
                this.$refs.onePicker.show();
            } else {
                this.$refs.picker.show();
            }
        },
        confirmPickerHushi(res){
            this.arrGoodsList = [];
            this.nPage = 0;
            this.sSelectValue = [this.arrHushiSelectList[res[0].index]];
            this.getGoodsList();
        },
        // 品类确认
        confirmPicker(res) {
            // this.arrChecked = []
            this.arrGoodsList = [];
            this.nPage = 0;
            this.sSelectValue = [this.arrSelectList[res[0].index]];
            this.getGoodsList();
        },
        // 打开选择数量
        openCountPiker(index) {
            // this.sSelectValue = [{value:1 }]
            this.nActive = index;
            this.$refs.countPicker.show();
        },
        // 确认修改数量
        confirmCountPicker(res) {
            // console.log(this.nActive);
            this.arrChecked[this.nActive].num = res[0].value;
        },

        // 关闭弹窗
        closeSearchModal() {
            this.$emit("update:bEditModalShow", false);
        },
        //下拉
        downRefresh(loaded) {
            this.arrGoodsList = [];
            this.nPage = 0;
            this.getGoodsList(() => {
                loaded("done");
            });
        },
        // 上拉加载
        upRefresh(loaded) {
            if (!this.isToEnd) {
                this.nPage++;
                this.getGoodsList(() => {
                    loaded("done");
                });
            } else {
                loaded("done");
            }
        },
        loadMore(){
            this.nPage++;
            this.getGoodsList();
        },
        // 关闭弹窗
        closeModal() {
            this.$emit("update:bEditModalShow", false);
        },
        // 获取产品列表
        async getGoodsList(callback) {
            this.$store.commit("loadSwitch", true);
            // console.log("----id", this.oGoodsInfo.goods_type_id);
            // 壁挂炉不使用goods_type_id进行搜索，而使用system_id进行搜索
            let system_id =
                this.sSelectValue[0].id === 2 ? this.sSelectValue[0].id : 0;
            let type_id;
            if (this.oGoodsInfo.goods_type_id) {
                type_id = this.oGoodsInfo.goods_type_id;
            } else {
                if (this.sSelectValue[0].id === 2) {
                    type_id = 0;
                } else {
                    type_id = this.sSelectValue[0].id;
                }
            }
            const resuqestData = {
                plan: 0,
                system_id: system_id,
                word: this.sKeyWord,
                type_id: type_id,
                page: this.nPage,
                limit: 10,
            };
            const resultData = await getGoodsList(resuqestData);
            resultData.data.data.result.list.forEach((item) => {
                item.num = 1;
                item.attr_one = []; // 右边重要卖点
                item.attr_two = []; // 下面参数
                item.attr.forEach((it) => {
                    it.attr_name = it.attr_name
                        .replace(/[\r\n]/g, "")
                        .replace(/\ +/g, ""); // 过滤空格、换行
                    it.attr_value = it.attr_value
                        ? it.attr_value
                              .replace(/[\r\n]/g, "")
                              .replace(/\ +/g, "")
                        : ""; // 过滤空格、换行
                    if (
                        it.attr_mean == 1 ||
                        it.attr_mean == 2 ||
                        it.attr_mean == 3
                    ) {
                        // 右边重要卖点分离
                        item.attr_one.push(it);
                    }
                    if (
                        it.attr_mean == 4 ||
                        it.attr_mean == 5 ||
                        it.attr_mean == 6
                    ) {
                        // 下面参数分离
                        item.attr_two.push(it);
                    }
                });
            });
            if (resultData.data.data.result.list.length === 0) {
                this.isToEnd = true;
            } else {
                this.isToEnd = false;
                this.arrGoodsList = [
                    ...this.arrGoodsList,
                    ...resultData.data.data.result.list,
                ];
            }
            this.$store.commit("loadSwitch", false);
            this.isNotData = this.arrGoodsList.length === 0 ? true : false;
            callback && callback();
        },
        // 修复键盘弹起bug
        changeBlur() {
            let u = navigator.userAgent,
                app = navigator.appVersion;
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isIOS) {
                setTimeout(() => {
                    const scrollHeight =
                        document.documentElement.scrollTop ||
                        document.body.scrollTop ||
                        0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 200);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.edit-modal-mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 888;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    .edit-modal {
        width: 660px;
        border-radius: 20px;
        background-color: #f5f8ff;
        overflow: hidden;
        // padding: 50px 30px;
        .edit-modal-header {
            background-color: rgb(47, 127, 237);
            height: 67px;
            line-height: 67px;
            text-align: center;
            font-size: 26px;
            color: rgb(255, 255, 255);
            position: relative;
            .close {
                position: absolute;
                top: 10px;
                right: 20px;
                background: url("~@/assets/images/ant/icon_del.png") top/100%
                    auto no-repeat;
                width: 40px;
                height: 40px;
            }
        }
        .edit-goods-list {
            overflow-x: scroll;
            overflow-y: hidden;
            // padding: 10px 0;
            ul {
                margin-top: 30px;
                display: flex;
                li {
                    flex-shrink: 0;
                    border: 1px solid #dce2fc;
                    border-radius: 10px;
                    background-color: rgb(255, 255, 255);
                    width: 555px;
                    height: 214px;
                    padding: 30px 20px;
                    margin-right: 15px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #bebebe;
                    position: relative;
                    .img-box {
                        width: 139px;
                        height: 169px;
                        display: flex;
                        align-items: center;
                        margin-right: 15px;
                        overflow: hidden;
                    }
                    img {
                        width: 139px;
                        // height: 169px;
                        flex-shrink: 0;
                    }
                    .goods-info {
                        .goods-name {
                            font-size: 24px;
                            color: rgb(45, 45, 45);
                            font-weight: bold;
                            span {
                                font-weight: normal;
                                font-size: 20px;
                                color: rgba(67, 67, 67, 0.8);
                            }
                        }
                        .goods-attr {
                            // margin-top: 10px;
                            div {
                                font-size: 20px;
                                color: rgba(67, 67, 67, 0.8);
                            }
                        }
                    }
                    .edit-count {
                        border: 1px solid #dce2fc;
                        background-color: rgb(245, 248, 255);
                        position: absolute;
                        right: 15px;
                        bottom: 15px;
                        width: 125px;
                        height: 38px;
                        border-radius: 35px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p {
                            text-align: center;
                            width: 80px;
                            font-size: 20px;
                            color: rgb(47, 127, 237);
                        }
                        &::after {
                            margin-left: 5px;
                            content: "";
                            display: inline-block;
                            background: url("~@/assets/images/ant/angle1.png")
                                top/100% auto no-repeat;
                            width: 11px;
                            height: 10px;
                        }
                    }
                    .count {
                        color: rgb(47, 127, 237);
                        font-size: 28px;
                        position: absolute;
                        right: 30px;
                        bottom: 30px;
                    }
                    .yx {
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: url("~@/assets/images/ant/yx.png") top/100%
                            auto no-repeat;
                        background-position: -7px -12px;
                        // width: 90px;
                        // height: 38px;
                        width: 107px;
                        height: 51px;
                    }
                    .delete {
                        position: absolute;
                        top: 5px;
                        right: 6px;
                        background: url("~@/assets/images/ant/form/icon_del2.png")
                            top/100% auto no-repeat;
                        // background-position: 10px -9px;
                        // width: 90px;
                        // height: 38px;
                        width: 35px;
                        height: 35px;
                    }
                }
            }
        }
        .edit-modal-content {
            padding: 0 30px;
            .edit-modal-top {
                display: flex;
                align-items: center;
                .search {
                    margin-top: 40px;
                    border-width: 2px;
                    border-color: rgb(47, 127, 237);
                    border-style: solid;
                    width: 100%;
                    height: 63px;
                    border-radius: 30px;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 40px;
                    img {
                        width: 34px;
                        height: 34px;
                        flex-shrink: 0;
                        margin-right: 20px;
                    }
                    input {
                        width: 100%;
                        font-size: 26px;
                        color: rgb(45, 45, 45);
                        background: transparent;
                    }
                }
                .select {
                    margin-left: 15px;
                    border-width: 2px;
                    border-color: rgb(47, 127, 237);
                    border-style: solid;
                    width: 250px;
                    height: 63px;
                    border-radius: 30px;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .select-icon {
                        // margin-top: 5px;
                        margin-left: 10px;
                        width: 18px;
                        height: 16px;
                        flex-shrink: 0;
                        background: url("~@/assets/images/ant/map/arrow_blue.png")
                            top/100% auto no-repeat;
                    }
                    .name {
                        width: 120px;
                        height: 32px;
                        overflow: hidden;
                        flex-shrink: 0;
                        line-height: 32px;
                    }
                }
            }
            .tag {
                // margin-top: 40px;
                ul {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    li {
                        padding: 14px;
                        border: 1px solid #dce2fc;
                        border-radius: 10px;
                        background-color: rgb(255, 255, 255);
                        font-size: 24px;
                        color: rgb(47, 127, 237);
                        margin-bottom: 15px;
                        span {
                            font-size: 22px;
                            color: rgb(67, 67, 67);
                        }
                    }
                }
            }
            .goods-list {
                border: 1px solid #dce2fc;
                border-radius: 10px;
                background-color: rgb(255, 255, 255);
                height: 522px;
                padding: 30px 20px;
                overflow: auto;
                .goods-item {
                    padding: 10px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #bebebe;
                    position: relative;
                    & > img {
                        width: 139px;
                        height: 169px;
                        flex-shrink: 0;
                        margin-right: 15px;
                    }
                    .goods-info {
                        p {
                            font-size: 24px;
                            color: rgb(45, 45, 45);
                            font-weight: bold;
                            span {
                                font-weight: normal;
                                font-size: 20px;
                                color: rgba(67, 67, 67, 0.8);
                            }
                        }
                        .goods-attr {
                            // margin-top: 15px;
                            div {
                                font-size: 20px;
                                color: rgba(67, 67, 67, 0.8);
                            }
                        }
                    }
                    .add-btn {
                        position: absolute;
                        right: 15px;
                        top: 60px;
                        width: 100px;
                        height: 45px;
                        border: 2px solid #2f7fed;
                        // background-color: #fff;
                        border-radius: 40px;
                        font-size: 28px;
                        color: #2f7fed;
                        text-align: center;
                        line-height: 45px;
                    }
                    .no-checked {
                        position: absolute;
                        top: 10px;
                        left: 0px;
                        background: url("~@/assets/images/ant/no_checked.png")
                            top/100% auto no-repeat;
                        width: 30px;
                        height: 30px;
                    }
                    .checked {
                        position: absolute;
                        top: 10px;
                        left: 0px;
                        background: url("~@/assets/images/ant/checked.png")
                            top/100% auto no-repeat;
                        width: 30px;
                        height: 30px;
                    }
                    .edit-count {
                        border: 1px solid #dce2fc;
                        background-color: rgb(245, 248, 255);
                        position: absolute;
                        right: 15px;
                        top: 53px;
                        width: 125px;
                        height: 38px;
                        border-radius: 35px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p {
                            text-align: center;
                            width: 80px;
                            font-size: 20px;
                            color: rgb(47, 127, 237);
                        }
                        &::after {
                            margin-left: 5px;
                            content: "";
                            display: inline-block;
                            background: url("~@/assets/images/ant/angle1.png")
                                top/100% auto no-repeat;
                            width: 11px;
                            height: 10px;
                        }
                    }
                }
            }
        }
        .edit-btn {
            margin-top: 30px;
            margin-bottom: 30px;
            display: flex;
            justify-content: center;
            .confirm-btn {
                width: 290px;
                height: 80px;
                background-color: #2f7fed;
                border-radius: 40px;
                font-size: 32px;
                color: #fff;
            }
        }
    }
}
.collapse-enter-active {
    transition: all 0.8s ease;
}
.collapse-leave-active {
    transition: all 0.8s ease;
}
.collapse-enter,
.collapse-leave-to {
    transform: translateY(540px);
}

.collapse-list-enter-active {
    transition: all 0.5s ease;
}
.collapse-list-leave-active {
    transition: all 0.5s ease;
}
.collapse-list-enter,
.collapse-list-leave-to {
    transform: translateY(-540px);
}

.dropload-tip {
    text-align: center;
    font-size: 24px;
    padding: 10px 0;
    background-color: #fff;
    margin-top: 20px;
}
.not-data {
    text-align: center;
    font-size: 24px;
    height: 100%;
}

.fade-in {
    animation: fadeIn 0.5s ease forwards;
}
.fade-out {
    animation: fadeOut 0.5s ease forwards;
}
@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>
